import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { StepBody, StepHeader, StepNav } from "../Hikvision/HikvisionWizardParts";

const Field = ({ label, children }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label style={{ fontSize: "13px", fontWeight: 600, color: "#2d2d2d" }}>{label}</label>
        {children}
    </div>
);

// Camect username is always "admin", so only the address & password are asked for.
// onSkip - only passed after a failed connection test, shows "Continue without connection"
const WizardStepCamectForm = ({ camectDetails, setCamectDetails, connectionError, onNext, onBack, onSkip, skipNote }) => {
    const set = (key) => (e) => setCamectDetails(prev => ({ ...prev, [key]: e.target.value }));
    const canContinue = camectDetails.address.trim() && camectDetails.password;

    return (
        <>
            <StepHeader title="Camect details" subtitle="Enter the Camect's address and password" />
            <StepBody style={{ gap: "14px" }}>
                {connectionError && (
                    <div style={{ padding: "10px 14px", borderRadius: "8px", background: "#fdecea", color: "#c0392b", fontSize: "13px" }}>
                        <i className="pi pi-exclamation-triangle" style={{ marginRight: "8px" }} />
                        {connectionError}
                    </div>
                )}
                <Field label="IP address / domain name">
                    <InputText value={camectDetails.address} onChange={set("address")} autoComplete="off" />
                </Field>
                <Field label="Password">
                    <Password value={camectDetails.password} onChange={set("password")} feedback={false} toggleMask inputStyle={{ width: "100%" }} style={{ width: "100%" }} autoComplete="new-password" />
                </Field>
            </StepBody>
            {onSkip && skipNote && (
                <small style={{ color: "#9e9e9e", textAlign: "right" }}>{skipNote}</small>
            )}
            <StepNav
                onBack={onBack}
                onNext={onNext}
                nextLabel="Test connection"
                nextIcon="pi pi-wifi"
                nextDisabled={!canContinue}
                secondaryAction={onSkip ? { label: "Continue without connection", icon: "pi pi-forward", onClick: onSkip, disabled: !canContinue } : undefined}
            />
        </>
    );
};

export default WizardStepCamectForm;
